import { darkTheme, MeetingStatus, useMeetingStatus, UserActivityProvider } from 'amazon-chime-sdk-component-library-react'
import { ThemeProvider as ScThemeProvider } from 'styled-components'

import { Box, ButtonGroup } from '@mui/material'

import VideoTileGrid from '@/components/chime-sdk/grid/VideoTileGrid'
import NoRemoteVideo from '@/components/ui/meeting/NoRemoteVideo'
import ControlBar from '@/components/chime-sdk/controls/ControlBar'
import AudioInputControl from '@/components/chime-sdk/controls/AudioInputControl'
import VideoInputControl from '@/components/chime-sdk/controls/VideoInputControl'
import DeviceSelectionControl from '@/components/chime-sdk/controls/DeviceSelectionControl'
import ScreenShareControl from '@/components/chime-sdk/controls/ScreenShareControl'
import AttendeeControl from '@/components/chime-sdk/controls/AttendeeControl'
import AudioOutputControl from '@/components/chime-sdk/controls/AudioOutputControl'
import { useNonDefaultDeviceChime } from '@/hooks/useNonDefaultDeviceChime'
import { useMeetingSession } from '../model/useMeetingSession'

export function MeetingDisplay({ expertiseMeetingId }: { expertiseMeetingId: string }) {
  const meetingStatus = useMeetingStatus()

  useNonDefaultDeviceChime()
  const { localAttendeeInfo } = useMeetingSession(expertiseMeetingId)

  return (
    <ScThemeProvider theme={darkTheme}>
      <UserActivityProvider>
        <Box sx={{ height: '100%', position: 'relative' }}>
          <VideoTileGrid layout="featured" localAttendeeName="Me" noRemoteVideoView={<NoRemoteVideo />} />
          {meetingStatus === MeetingStatus.Succeeded && localAttendeeInfo && (
            <>
              <ControlBar position="absolute">
                <AudioInputControl attendeeId={localAttendeeInfo.AttendeeId} />
                <VideoInputControl />
                <AudioOutputControl />
                <DeviceSelectionControl showCustomDevices={false} />
              </ControlBar>
              <ControlBar anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }} position="absolute">
                <ButtonGroup disableElevation>
                  <ScreenShareControl sx={{ borderTopRightRadius: 'unset', borderBottomRightRadius: 'unset' }} />
                  <AttendeeControl sx={{ borderTopLeftRadius: 'unset', borderBottomLeftRadius: 'unset' }} />
                </ButtonGroup>
              </ControlBar>
            </>
          )}
        </Box>
      </UserActivityProvider>
    </ScThemeProvider>
  )
}
